/* eslint-disable */
import React, { useState } from 'react';
import { db } from './firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { generarIdLibro } from './constants';

// ── Parsear CSV de Goodreads ──────────────────────────────────────────────────
// Parser carácter a carácter (no por líneas) porque las reseñas exportadas por
// Goodreads suelen contener saltos de línea dentro de campos entre comillas —
// partir primero por '\n' rompía la alineación de columnas de esas filas.
function filasCSV(texto) {
  const filas = [];
  let fila = [];
  let campo = '';
  let enComillas = false;
  for (let i = 0; i < texto.length; i++) {
    const c = texto[i];
    if (enComillas) {
      if (c === '"') {
        if (texto[i + 1] === '"') { campo += '"'; i++; } // comilla escapada ""
        else enComillas = false;
      } else {
        campo += c;
      }
    } else if (c === '"') {
      enComillas = true;
    } else if (c === ',') {
      fila.push(campo); campo = '';
    } else if (c === '\r') {
      // ignorar, el \n que le sigue cierra la fila
    } else if (c === '\n') {
      fila.push(campo); campo = '';
      filas.push(fila); fila = [];
    } else {
      campo += c;
    }
  }
  if (campo !== '' || fila.length > 0) { fila.push(campo); filas.push(fila); }
  return filas.filter(f => f.some(c => c.trim() !== ''));
}

function parsearGoodreadsCSV(texto) {
  const filas = filasCSV(texto);
  if (filas.length < 2) return [];

  // Cabeceras de Goodreads
  const cabeceras = filas[0].map(h => h.trim());

  const libros = [];
  for (let i = 1; i < filas.length; i++) {
    const cols = filas[i].map(c => c.trim());

    const fila = {};
    cabeceras.forEach((h, idx) => { fila[h] = cols[idx] || ''; });

    const titulo = fila['Title'] || fila['title'] || '';
    const autor = fila['Author'] || fila['author'] || fila['Author l-f'] || '';
    const estante = fila['Exclusive Shelf'] || fila['exclusive_shelf'] || '';
    const isbn = fila['ISBN13'] || fila['isbn13'] || '';

    if (!titulo) continue;

    // Mapear estantes de Goodreads a estados de Leemos
    let estado = null;
    if (estante === 'read') estado = 'leido';
    else if (estante === 'currently-reading') estado = 'leyendo';
    else if (estante === 'to-read') estado = 'quiero_leer';

    if (!estado) continue;

    libros.push({ titulo, autor: autor.split(',')[0].trim(), estado, isbn });
  }
  return libros;
}

const GOOGLE_BOOKS_API_KEY = 'AIzaSyDmTfy3ePtPB-LUZjMkaXQdOU2CmSGT5cU';

async function buscarPortadaGoogleBooks(titulo, autor) {
  try {
    const q = encodeURIComponent(`${titulo} ${autor || ''}`);
    const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=5&key=${GOOGLE_BOOKS_API_KEY}`);
    if (!resp.ok) return '';
    const data = await resp.json();
    const item = data.items?.find(it => it.volumeInfo?.imageLinks);
    if (!item) return '';
    const links = item.volumeInfo.imageLinks;
    const raw = links.thumbnail || links.smallThumbnail || '';
    if (!raw) return '';
    return raw.replace('http://', 'https://').replace(/zoom=\d/, 'zoom=1').replace('&edge=curl', '');
  } catch { return ''; }
}
export function ImportarGoodreads({ userId, onCompletado, onCerrar }) {
  const [fase, setFase] = useState('instrucciones');
  const [hayLimite, setHayLimite] = useState(false);
  const [progreso, setProgreso] = useState(0);
  const [total, setTotal] = useState(0);
  const [importados, setImportados] = useState(0);
  const [errores, setErrores] = useState(0);

  const procesarArchivo = async (archivo) => {
    const texto = await archivo.text();
    const libros = parsearGoodreadsCSV(texto);
    
    if (libros.length === 0) {
      setFase('error');
      return;
    }

    // Límite de seguridad — máximo 2000 libros por importación
    const librosLimitados = libros.slice(0, 2000);
    setHayLimite(libros.length > 2000);

    setFase('importando');
    setTotal(librosLimitados.length);
    setProgreso(0);
    setImportados(0);
    setErrores(0);

    let ok = 0;
    let err = 0;

    for (let i = 0; i < librosLimitados.length; i++) {
      const libro = librosLimitados[i];
      try {
        const libroId = generarIdLibro(libro.titulo, libro.autor);

        // Buscar portada en Google Books (con pausa cada 5 libros para no saturar)
        let portada = '';
        if (i % 5 === 0 && i > 0) await new Promise(r => setTimeout(r, 300));
        portada = await buscarPortadaGoogleBooks(libro.titulo, libro.autor);

        const libroData = {
          id: libroId,
          titulo: libro.titulo,
          autor: libro.autor,
          portada,
          descripcion: '',
        };
        await setDoc(doc(db, "estados_lectura", `${libroId}_${userId}`), {
          libroId,
          userId,
          estado: libro.estado,
          libro: libroData,
          fecha: serverTimestamp(),
          importadoDeGoodreads: true,
        }, { merge: true });
        ok++;
      } catch (e) { err++; }
      setProgreso(i + 1);
      setImportados(ok);
      setErrores(err);
    }

    setFase('resultado');
    if (onCompletado) onCompletado(ok);
  };

  return (
    <div className="modal-overlay" onClick={fase === 'instrucciones' ? onCerrar : undefined}>
      <div className="modal-content" style={{ maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
        
        {fase === 'instrucciones' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 900 }}>Importar desde Goodreads</h3>
              <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '20px' }}>✕</button>
            </div>

            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 20px', lineHeight: '1.6' }}>
              Trae todos tus libros de Goodreads a Leemos en segundos.
            </p>

            {/* Pasos */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              {[
                { num: '1', texto: 'Ve a goodreads.com → Mi cuenta → Importar y exportar' },
                { num: '2', texto: 'Pulsa "Exportar biblioteca" y descarga el archivo CSV' },
                { num: '3', texto: 'Súbelo aquí abajo' },
              ].map(p => (
                <div key={p.num} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#1DB954', color: 'black', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 900, flexShrink: 0, marginTop: '1px' }}>{p.num}</div>
                  <p style={{ margin: 0, fontSize: '14px', color: '#aaa', lineHeight: '1.5' }}>{p.texto}</p>
                </div>
              ))}
            </div>

            {/* Info de lo que se importa */}
            <div style={{ background: '#141414', borderRadius: '10px', padding: '14px', border: '1px solid #1e1e1e', marginBottom: '20px' }}>
              <p style={{ margin: '0 0 8px', fontSize: '13px', fontWeight: 'bold', color: 'white' }}>Se importarán:</p>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {[
                  { label: 'Leídos', color: '#FFD700' },
                  { label: 'Leyendo', color: '#1DB954' },
                  { label: 'Quiero leer', color: '#888' },
                ].map(e => (
                  <span key={e.label} style={{ background: `${e.color}22`, color: e.color, border: `1px solid ${e.color}44`, borderRadius: '8px', padding: '4px 10px', fontSize: '12px', fontWeight: 'bold' }}>{e.label}</span>
                ))}
              </div>
            </div>

            {/* Input de archivo */}
            <label style={{ display: 'block', background: '#1DB954', color: 'black', borderRadius: '25px', padding: '14px', fontWeight: 900, cursor: 'pointer', fontSize: '15px', textAlign: 'center', transition: '0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#1ed760'}
              onMouseLeave={e => e.currentTarget.style.background = '#1DB954'}>
              Seleccionar archivo CSV
              <input type="file" accept=".csv" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) procesarArchivo(e.target.files[0]); }} />
            </label>

            <p style={{ fontSize: '11px', color: '#333', textAlign: 'center', marginTop: '12px' }}>
              Solo se leerá localmente. No enviamos tu archivo a ningún servidor.
            </p>
          </>
        )}

        {fase === 'importando' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📚</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '20px', fontWeight: 900 }}>Importando tu biblioteca...</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 24px' }}>
              {progreso} de {total} libros procesados{hayLimite ? ` (primeros 2.000 de ${total})` : ''}
            </p>
            <div style={{ height: '8px', background: '#1a1a1a', borderRadius: '8px', overflow: 'hidden', marginBottom: '8px' }}>
              <div style={{ height: '100%', width: `${total > 0 ? (progreso / total) * 100 : 0}%`, background: '#1DB954', borderRadius: '8px', transition: '0.3s ease' }} />
            </div>
            <p style={{ fontSize: '12px', color: '#444', margin: 0 }}>No cierres esta ventana</p>
          </div>
        )}

        {fase === 'resultado' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#1DB95422', border: '2px solid #1DB954', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: '28px' }}>✓</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '22px', fontWeight: 900, color: 'white' }}>¡Importación completada!</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 24px' }}>
              Tu biblioteca de Goodreads ya está en Leemos
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '24px' }}>
              <div style={{ background: '#141414', borderRadius: '10px', padding: '16px', border: '1px solid #1e1e1e' }}>
                <p style={{ margin: '0 0 4px', fontSize: '28px', fontWeight: 900, color: '#1DB954' }}>{importados}</p>
                <p style={{ margin: 0, fontSize: '13px', color: '#555' }}>libros importados</p>
              </div>
              {errores > 0 && (
                <div style={{ background: '#141414', borderRadius: '10px', padding: '16px', border: '1px solid #1e1e1e' }}>
                  <p style={{ margin: '0 0 4px', fontSize: '28px', fontWeight: 900, color: '#f44336' }}>{errores}</p>
                  <p style={{ margin: 0, fontSize: '13px', color: '#555' }}>no importados</p>
                </div>
              )}
            </div>
            <button onClick={onCerrar} className="btn-verde">Ver mi biblioteca</button>
          </div>
        )}
        {fase === 'error' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '20px', fontWeight: 900, color: 'white' }}>Archivo no válido</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 24px' }}>
              No se encontraron libros. Asegúrate de que es el CSV de exportación de Goodreads.
            </p>
            <button onClick={() => setFase('instrucciones')} className="btn-outline">Intentar de nuevo</button>
          </div>
        )}
      </div>
    </div>
  );
}
